export const SET_WORK_CALENDAR_DATA = "SET_WORK_CALENDAR_DATA";
export const CLEAR_WORK_CALENDAR_DATA = "CLEAR_WORK_CALENDAR_DATA";
export const SET_WORK_CALENDAR_LOADING = "SET_WORK_CALENDAR_LOADING";
export const SET_SELECTED_DISPLAY_METRIC = "SET_SELECTED_DISPLAY_METRIC";

export function setWorkCalendarData(data) {
  return {
    type: SET_WORK_CALENDAR_DATA,
    payload: data,
  };
}

export function clearWorkCalendarData() {
  return {
    type: CLEAR_WORK_CALENDAR_DATA,
  };
}

export function setWorkCalendarLoading(isLoading) {
  return {
    type: SET_WORK_CALENDAR_LOADING,
    payload: isLoading,
  };
}

export function setSelectedDisplayMetric(metricValue) {
  return {
    type: SET_SELECTED_DISPLAY_METRIC,
    payload: metricValue,
  };
}
